import { render, staticRenderFns } from "./UploadCV.vue?vue&type=template&id=0de8da9a&"
import script from "./UploadCV.vue?vue&type=script&lang=js&"
export * from "./UploadCV.vue?vue&type=script&lang=js&"
import style0 from "./UploadCV.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports